<template>
    <div class="caracteristicas">
        <b-container>
            <div class="caracteristicas-wrapper">
                <b-row class="mb-5">
                    <b-col lg="6" class="mb-4">
                        <img class="img-card" src="../assets/img/img_card_front.png" alt="">
                    </b-col>
                    <b-col lg="6" class="align-self-center mb-4">
                        <div class="txt-header mb-4">
                            <span>Recibe tu <span class="text-purple">Tarjeta Garlan's</span><br>
                            </span>
                            <span class="black-bg">y obtén 15% de descuento</span> 
                            <span> más<br v-if="mobile"> $10dlls por apertura</span>
                        </div>
                        <p>Además de múltiples beneficios</p>
                        <a href="https://apply.garlans.com/">Aplica hoy</a>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" class="mb-4">
                        <b-row class="mb-4">
                            <b-col cols="4" class="align-self-center text-center">
                                <img class="img-beneficiostop" src="../assets/img/icn_benefit1.svg" alt="">
                            </b-col>
                            <b-col cols="8" class="align-self-center">
                                <p>Tasa de interés muy baja 1.92%</p>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="4" class="mb-4">
                        <b-row class="mb-4">
                            <b-col cols="4" class="align-self-center text-center">
                                <img class="img-beneficiostop2" src="../assets/img/icn_benefit2.svg" alt="">
                            </b-col>
                            <b-col cols="8" class="align-self-center">
                                <p>Programa de lealtad</p>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="4" class="mb-4">
                        <b-row class="mb-4">
                            <b-col cols="4" class="align-self-center text-center">
                                <img class="img-beneficiostop2" src="../assets/img/icn_benefit3.svg" alt="">
                            </b-col>
                            <b-col cols="8" class="align-self-center">
                                <p>20% de descuento en tu cumpleaños</p>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" class="mb-4">
                        <b-row>
                            <b-col cols="4" class="align-self-center text-center">
                                <img class="img-beneficios" src="../assets/img/icn_benefit4.svg" alt="">
                            </b-col>
                            <b-col cols="8" class="align-self-center">
                                <p>Cargos diferidos en fechas especiales</p>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="4" class="mb-4">
                        <b-row>
                            <b-col cols="4" class="align-self-center text-center">
                                <img class="img-beneficios" src="../assets/img/icn_benefit5.svg" alt="">
                            </b-col>
                            <b-col cols="8" class="align-self-center">
                                <p>Entregas a domicilio rápidas y seguras</p>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="4" class="mb-4">
                        <b-row>
                            <b-col cols="4" class="align-self-center text-center">
                                <img class="img-beneficios" src="../assets/img/icn_benefit6.svg" alt="">
                            </b-col>
                            <b-col cols="8" class="align-self-center">
                                <p>Descuentos exclusivos</p>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                mobile: window.innerWidth < 421
            }
        }
    }
</script>

<style scoped>
.caracteristicas{
    padding: 5% 0;
}
.img-card{
    width: 120%;
}
a,
a:focus,
a:hover{
    color: #fff;
    background: #AF00B1;
    text-align: center;
    text-decoration: none;
    padding: 12px 40px;
    font-weight: bold;
    margin-bottom: 30px;
    display: block;
    width: 50%;
}
p{
    font-size: 24px;
}
.caracteristicas-wrapper{
    background-color: rgba(0,0,0,0.05) ;
    border-radius: 30px;
    padding: 5% 10%;
}
.txt-header{
    font-family: futura-pt, sans-serif;
    font-weight: 500;
    font-style: normal;
    color: #000;
    font-size: 50px;
    line-height: 1.1;
}
.text-purple{
    color:#AF00B1;
    font-weight: 600;
}
.black-bg{
    background: #000;
    color: #fff;
    padding: 0 5px;
    font-weight: 600;
}
.img-beneficiostop{
    height: 65px;
}
.img-beneficiostop2,
.img-beneficiostop3{
    height: 60px;
}
.img-beneficios{
    height: 80px;
}
.align-self-center p{
    margin-bottom: 0;
}
@media (max-width: 1600px) {
    .txt-header{
        font-size: 40px;
    }
    p{
        font-size: 18px;
    }
    .img-beneficiostop{
        height: 55px;
    }
    .img-beneficiostop2,
    .img-beneficiostop3{
        height: 50px;
    }
    .img-beneficios{
        height: 70px;
    }
}
@media (max-width: 768px) {
    .txt-header{
        font-size: 29px;
    }
    p{
        font-size: 16px;
    }
    .img-beneficios{
        width: 100%;
    }
    a,
    a:focus,
    a:hover{
       width: 100%; 
    }
    .caracteristicas-wrapper{
        padding: 5% 7%;
    }
    .caracteristicas{
        padding: 10% 0;
    }
}
@media (min-width: 1600px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
      max-width: 1550px !important;
  }
}
</style>